import promoBreakpoints from './promoBreakpoints';

const promoMedia = {
    mobile375: `@media screen and (min-width: ${promoBreakpoints.mobile375})`,
    retina375: `@media screen and (min-width: ${promoBreakpoints.mobile375})   and (-webkit-min-device-pixel-ratio: 2), screen and (${promoBreakpoints.mobile375})   and (min-resolution: 192dpi)`,
    retina: `@media screen and (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)`,
    tablet744: `@media screen and (min-width: ${promoBreakpoints.tablet744})`,
    retina744: `@media screen and (min-width: ${promoBreakpoints.tablet744})   and (-webkit-min-device-pixel-ratio: 2), screen and (${promoBreakpoints.tablet744})   and (min-resolution: 192dpi)`,
    desktop1440: `@media screen and (min-width: ${promoBreakpoints.desktop1440})`,
    retina1440: `@media screen and (min-width: ${promoBreakpoints.desktop1440}) and (-webkit-min-device-pixel-ratio: 2), screen and (${promoBreakpoints.desktop1440}) and (min-resolution: 192dpi)`,
};

export default promoMedia;
